import React from 'react'

export const ReviewWrapUpIntro: React.FC = () => {
  return (
    <div className="mb-6">
      <h2 className="mb-3 text-xl font-bold text-graphite-grey md:text-2xl">Anything else we should know?</h2>
      <p className="text-sm leading-relaxed text-gray-600 md:text-base">
        Tell us about anything we missed. Recruit a friend to work there? Were they flexible with scheduling? This box
        is all yours, fill in the gaps for us.
      </p>
    </div>
  )
}
